import { IconProps } from "../../utils/global-types/global-types";

const DuplicateIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12 3.5v8a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 3 11.5v-8A1.5 1.5 0 0 1 4.5 2h6A1.5 1.5 0 0 1 12 3.5M13.5 5H13v6.5a2.5 2.5 0 0 1-2.5 2.5H6v.5A1.5 1.5 0 0 0 7.5 16h6a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 13.5 5"
      ></path>
    </svg>
  );
};

export default DuplicateIcon;
